module.exports = __webpack_public_path__ + "static/media/horizontal.0df11371.svg";